<template>
  <div id="app">
    <div class="main" style="max-width: 580px;margin: 0 auto;">
      <b-loading :active="isLoading" :is-full-page="false" animation=""></b-loading>
      <div class="error-view" v-if="error">Error loading page, please try again later</div>
      <transition v-else name="fade" mode="out-in">
        <router-view v-if="!isLoading"/>
      </transition>
    </div>
    <br/>
    <!--<a class="has-text-white" @click="$store.state.language = $store.state.language === 'en' ? 'ar' : 'en'">Language</a>-->

  </div>
</template>

<script>
export default {
  name: 'app',
  data: () => {
    return {
      error: false,
      isLoading: true
    }
  },
  async mounted() {

    this.$store.state.language = this.$route.query.lang === 'ar' ? 'ar' : 'en'

    if (this.$store.state.language === 'ar') {
      document.body.setAttribute('dir', 'rtl')
    }

    if (this.$route.path === '/demo') {
      this.isLoading = false
      return
    }

    if (this.$route.query.token)
      this.$store.commit('setToken', this.$route.query.token)

    try {
      await this.$store.dispatch('getUserInfo')

      await this.$store.dispatch('getPossibleSettings', this.$store.state.userInfo.hasPRAL8)
    } catch (e) {
      this.error = true
    }
    this.isLoading = false
  }
}
</script>

<style lang="scss">

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #d12984;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

@font-face {
  font-family: "Nunito";
  unicode-range: U+600-6FF;
  font-display: auto;
  src: url("./assets/fonts/QTZain-Reguar-Final.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Nunito";
  unicode-range: U+600-6FF;
  font-display: auto;
  src: url("./assets/fonts/QTZain-Bold-Final.ttf");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Nunito";
  font-display: auto;
  src: url("./assets/fonts/NunitoSans-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Nunito";
  font-display: auto;
  src: url("./assets/fonts/NunitoSans-Bold.ttf");
  font-weight: bold;
  font-style: normal;
}

*, body, button, input, select, textarea {
  font-family: "Nunito", Helvetica, sans-serif;
}

[dir='rtl'] small {
  font-size: 1em !important;
}

input, select, textarea {
  font-family: Arial, Helvetica, sans-serif !important;
}

[dir='rtl'] .button .icon:first-child:not(:last-child) {
  margin-left: 0.1875em;
  margin-right: calc(-0.375em - 1px);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

img {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
  -ms-interpolation-mode: bicubic;
}

.title-bar-left, .title-bar-right {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
}

header {
  display: flex;
}

.icon {
  font-size: 1.3em;
  padding: 0 8px;
}

.float-right {
  float: right;
}

[dir='rtl'] .float-right {
  float: left !important;
}

.float-left {
  float: left;
}

[dir='rtl'] .float-left {
  float: right !important;
}

.align-left {
  text-align: left;
}

[dir='rtl'] .align-left {
  text-align: right;
}

.align-right {
  text-align: right;
}

[dir='rtl'] .align-right {
  text-align: left;
}

.text-center {
  text-align: center;
}

i.fa {
  color: white;
}

.vue-slider-process {
  background-color: #7bc440 !important;
}


.switch input[type=checkbox]:checked + .check.is-success {
  background: #7bc440 !important;
}

.circle-selector.swiper-slide {
  color: black;
  opacity: 0.3;
  font-weight: bold;
  font-size: 1.1em !important;
  transition: all 0.7s ease;

}

.circle-selector.swiper-slide-active {
  opacity: 1;
}

.light-box {
  width: 85vw;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.2)
}

.notification i {
  color: black !important;
}

li {
  margin-bottom: 20px;
  padding: 7px;
  background: #ffffff1c;
  border-radius: 10px;
  font-size: 0.8em;
}

.datepicker .dropdown-content {
  background-color: #0ea59f;
}

[dir='rtl'] .switch input[type=checkbox]:checked + .check:before {
  transform: translate3d(-100%, 0, 0);
}

[dir='rtl'] .field.is-grouped > .control:not(:last-child) {
  margin-right: inherit;
  margin-left: 0.75rem;
}

.margin-right-0 {
  margin-right: 0 !important;
}

[dir='rtl'] .margin-right-0 {
  margin-right: inherit !important;
  margin-left: 0 !important;
}


.margin-left-0 {
  margin-left: 0 !important;
}

[dir='rtl'] .margin-left-0 {
  margin-left: inherit !important;
  margin-right: 0 !important;
}

.input {
  display: inline-block !important;
}

.vue-slider-mark-step {
  background-color: inherit !important;
}

.pink-btn {
  width: 100% !important;
  color: #D12B8A !important;
  font-weight: bold !important;
  background-color: inherit !important;
  border-color: #D12B8A !important;
  height: 50px !important;
}

.no-plan-icon {
  color: #b2b2b2 !important;
}

a:hover {
  color: inherit !important;
}


.fade-enter-active, .fade-leave-active {
  transition: all .2s;
  /*transform: translateX(0px);*/
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  /*transform: translateX(-40px);*/
}


.tab-btn:first-child {
  margin-right: 5px;
}

[dir='rtl'] .tab-btn:first-child {
  margin-left: 5px !important;
  margin-right: 0 !important;
}

.tab-btn:not(:first-child) {
  margin-left: 5px;
}

[dir='rtl'] .tab-btn:not(:first-child) {
  margin-right: 5px !important;
  margin-left: 0 !important;

}

.tab-btn:only-child {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.tab-btn:hover {
  color: inherit;
}

.tab-btn {
  flex: 1;
  padding: 10px;
  background: rgba(0, 0, 0, 0.29);
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 0.7em;
  font-weight: bold;
  cursor: pointer;
}

[dir='rtl'] .tab-btn {
  font-size: 0.85em;
}

.tab-btn-active {
  background: rgba(0, 0, 0, 0.6);

}

.error-view {
  margin: 10px;
  background: white;
  border-radius: 5px;
  padding: 10px;
}

.modal .animation-content {
  width: 95% !important;
}

.dialog .modal-card .modal-card-foot .button {
  width: 100%;
  font-family: Nunito, Helvetica, sans-serif;
  font-weight: 400 !important;
}

[dir='rtl'] .media-content {
  text-align: right !important;
}

[dir='rtl'] .modal-card-foot .button:not(:last-child) {
  margin-right: 0 !important;
  margin-left: 0.5em;
}

.text-right {
  text-align: right;
}

[dir='rtl'].text-left {
  text-align: left !important;
}

.vue-slider-dot {
  width: 50px !important;
  height: 50px !important;
  text-align: center;
}
</style>
